<div class="p-6 max-w-5xl mx-auto">
  <div class="flex flex-row justify-between items-center mb-5">
    <div>
      <h1 class="text-2xl font-semibold mb-1">Test notification send</h1>
      <p class="text-sm text-muted-color">User ID: {{ userId() }}</p>
    </div>
    <p-button icon="pi pi-arrow-left" label="Back" (onClick)="goBack()"></p-button>
  </div>

  <p class="text-sm text-muted-color mb-2">
    Enter a <code>NotificationInformation</code> payload and press send. The backend validates the shape before persisting.
  </p>

  <p class="text-sm text-muted-color mb-4 font-mono bg-surface-100 p-3 rounded border border-300 whitespace-pre-wrap">
    {{ examplePayload }}
  </p>

  <h3 class="text-lg font-semibold mb-2">Payload examples</h3>
  <div class="grid gap-4 mb-4 md:grid-cols-3">
    <div
      *ngFor="let example of examples"
      class="flex flex-col gap-2 rounded border border-300 bg-surface-100 p-3"
    >
      <div class="flex items-center justify-between">
        <span class="font-semibold">{{ example.title }}</span>
      </div>
      <p class="text-xs uppercase tracking-wide text-muted-color">{{ example.description }}</p>
      <pre class="text-xs font-mono whitespace-pre-wrap bg-white p-2 rounded border border-200">{{ example.payload }}</pre>
    </div>
  </div>

  <textarea
    pInputTextarea
    [value]="jsonInput()"
    (input)="jsonInput.set($any($event.target).value)"
    class="w-full rounded border border-300 bg-white p-3 text-sm font-mono min-h-[220px]"
    rows="12"
  ></textarea>

  <h3 class="text-lg font-semibold mt-6 mb-2">User data override (optional)</h3>
  <p class="text-sm text-muted-color mb-2">
    Provide <code>NotificationUserData</code> to override user context for this send.
  </p>
  <p class="text-sm text-muted-color mb-4 font-mono bg-surface-100 p-3 rounded border border-300 whitespace-pre-wrap">
    {{ userDataExample }}
  </p>
  <textarea
    pInputTextarea
    [value]="userDataInput()"
    (input)="userDataInput.set($any($event.target).value)"
    class="w-full rounded border border-300 bg-white p-3 text-sm font-mono min-h-[140px]"
    rows="6"
  ></textarea>

  <p class="text-sm text-red-600 mt-2" *ngIf="validationError()">
    {{ validationError() }}
  </p>

  <div class="flex flex-row gap-2 mt-4">
    <p-button
      label="Send notification"
      icon="pi pi-bell"
      (onClick)="sendTestNotification()"
      [loading]="loading()"
      [disabled]="loading()"
    ></p-button>
    <p-button
      label="Reset JSON"
      icon="pi pi-undo"
      severity="secondary"
      (onClick)="resetJson()"
      [disabled]="loading()"
    ></p-button>
  </div>
</div>
